export const BookingStatus = {
    PENDING: "PENDING",
    PENDING_PAYMENT: "PENDING_PAYMENT",
    PAYMENT_FAILED: "PAYMENT_FAILED",
    AWAITING_HOST_APPROVAL: "AWAITING_HOST_APPROVAL",
    REJECTED: "REJECTED",
    APPROVED: "APPROVED",
    CHECKED_IN: "CHECKED_IN",
    CANCELED: "CANCELED",
    COMPLETED: "COMPLETED",
    REFUNDED: "REFUNDED",
    EXPIRED: "EXPIRED",
} as const;

export const PaymentStatus = {
    NOT_PAID: "NOT_PAID",
    PENDING: "PENDING",
    PAID: "PAID",
    REFUNDED: "REFUNDED",
} as const;

export const ReviewType = {
    PROPERTY_REVIEW: "PROPERTY_REVIEW",
    GUEST_REVIEW: "GUEST_REVIEW",
} as const;

export const CancellationPolicy = {
    FLEXIBLE: "FLEXIBLE",
    MODERATE: "MODERATE",
    FIRM: "FIRM",
} as const;

export const PropertyStatus = {
    DRAFT: "DRAFT",
    PUBLISHED: "PUBLISHED",
} as const;

export const BookableDateStatus = {
    AVAILABLE: "AVAILABLE",
    ON_HOLD: "ON_HOLD",
    BOOKED: "BOOKED",
} as const;


export type BookingStatusType = typeof BookingStatus[keyof typeof BookingStatus];
export type PaymentStatusType = typeof PaymentStatus[keyof typeof PaymentStatus];
export type ReviewTypeType = typeof ReviewType[keyof typeof ReviewType];
export type CancellationPolicyType = typeof CancellationPolicy[keyof typeof CancellationPolicy];
export type PropertyStatusType = typeof PropertyStatus[keyof typeof PropertyStatus];
export type BookableDateStatusType = typeof BookableDateStatus[keyof typeof BookableDateStatus];
